import React, { useContext, useState } from 'react'
import {AiOutlineUser,AiOutlineKey} from 'react-icons/ai'
import styles from './loginSingup.module.css'
import  LogoSvg  from "../../assets/logo.js";
import { LoginSingupPageContext } from '../../context/loginSingupPageContext';
import { UserContext } from '../../context/userContext';
import { Redirect } from 'react-router-dom';

const Login= ()=>{
    const{setPageState,handleLogin}=useContext(LoginSingupPageContext);
    const{login}=useContext(UserContext)
    const [username,setUsername]=useState("");
    const [password,setPassword]=useState("");
    const {user} = useContext(UserContext);
const handleFormSubmit = (e)=>{
    e.preventDefault();
  
        var logindata={"username":username,"password":password}
        login(logindata);
       

    }





return(
    <div style={{width:"90%"}}>
        {user?<Redirect to="/"/>:""}
<div style={{textAlign:"center"}}>
                    <LogoSvg/>
                    <h1>Welcome</h1>
                    <span>Happy to see you again</span>
                </div>
                <br/>
                <form onSubmit={handleFormSubmit}>
                <div className={styles.input}>
                    <div className={styles.loginicon} ><AiOutlineUser/></div>
                    <input type="text" value={username} onChange={e=>setUsername(e.target.value)} />
                </div>
                <br/>
                <div className={styles.input}>
                    <div  className={styles.loginicon}><AiOutlineKey/></div>
                    <input type="password" value={password} onChange={e=>setPassword(e.target.value)} />
                </div>
                <div className={styles.check}>
                   
                    <a href="/">
                        forgot password?
                    </a>
                </div>
                <input type="submit" value="Log in"className={styles.btn}>
                </input>
                </form>
                
                <div onClick={()=>setPageState("signup")} className={styles.link}>Create new account</div>
                </div>)
}                

export default Login